import { DocumentCivilUnionFilterForm } from 'civil-status/view-models/document-civil-union-list';
import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValuesDocumentCivilUnionSearch: DocumentCivilUnionFilterForm = {
  page: 0,
  rowsPerPage: 10,
  orders: {},
  year: '',
  document: '',
  registry: null,
  portion: '',
  serie: '',
  matricola: '',
  surname: '',
  name: '',
  operationYear: '0',
  operationDocument: '0',
  operationRegistry: '0',
  operationPortion: '0',
  operationSerie: '0',
  operationMatricola: '0',
  operationSurname: '0',
  operationName: '0',
  operationMatricola2: '0',
  operationSurname2: '0',
  operationName2: '0',
};

const PageDocumentCivilUnionSearchInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesDocumentCivilUnionSearch}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageDocumentCivilUnionSearchInitializer.displayName =
  'Page search civil union initializer component';

export default PageDocumentCivilUnionSearchInitializer;
